export default `# Tim Qian

A full-stack JS developer and open-source activist.

## Contact

| [GitHub](htttps://github.com/timqian) | [Twitter](https://twitter.com/tim_qian) | [Email](mailto:timqian@t9t.io) | [Website](https://timqian.com) | [Blog](https://blog.t9t.io) | [Patreon](https://www.patreon.com/timqian) |

## Teck Stack

- Backend: Node.js; Express; AWS lambda; serverless; GraphQL; RabbitMQ
- Database: DynamoDB; MongoDB; Postgres; SQLite; AWS RDS; Redis
- Frontend: react.js; SASS/CSS; d3.js
- Chrome Extension: react.js; SASS/CSS;

## Projects (open source)

- **[chart.xkcd](https://github.com/timqian/chart.xkcd)**: xkcd styled chart lib.
  - 5.5k+ stars on GitHub, 100k downloads
  - Built with d3.js
- **[tomato-pie](https://github.com/t9tio/tomato-pie)**: A new UI for Pomodoro Technique. Schedule your time directly with a clock.
  - 1k+ active users
  - Built with pure HTML, CSS, JS
- **[repo-analytics](https://github.com/repo-analytics/repo-analytics.github.io)**: Thorough analytics for your GitHub repos.
  - 100+ users
  - Frontend: React.js; backend: node.js, AWS lambda, dynamodb

## Working Experience

- **[t9t.io](https://t9t.io)**: Indie Hacker; (2019/05 - now)
Trying to build something people want
- **[modelo.io](https://modelo.io)**: Backend developer; Backend leader; (2016/10 - 2019/05)
Lead a small backend team; Maintain and write backend code using node.js, GraphQL, PostgreSQL...
- **[ele.me](https://www.ele.me/)** (now part of [Alibaba](https://www.alibaba.com/)): Intern; (2016/05 - 2016/08)
Develop performance monitor system making use of node.js, MongoDB, Redis and koa
- **[Oracle China](https://oracle.com)**: Intern; (2015/07 – 2016/05)
Maintain automatic testing system code(written in node.js) in the OATS team.

## Education

- Master’s Degree in computational physics, **Shanghai University** *(2014 – 2017)*
- Bachelor’s Degree in physics, **Ningbo University** *(2010 – 2014)*
`